define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    const i18n = require('i18n');
    var _ = require('underscore');
    const getConfig = require('modules/user/user.validation.config');
    const userValidationConfig = getConfig();
    var validationHelpers = require('modules/user/user.validation.helpers');

    const passRegExp = /^(?=\S*[a-zA-Z])(?=\S*\d)\S{5,10}$/;
    const regexInt = /^\d+$/;

    module.exports = function() {
        return {
            ...userValidationConfig,
            password: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.required')
                },
                length: {
                    min: 8,
                    max: 20,
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.length')
                },
                regexp: {
                    regexp: passRegExp,
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.regexp')
                }
            },
            depositCountLimit: {
                fn: {
                    fn: function($inputs, config, form) {
                        var options = form.options.data;
                        var data = _.mapObject(form.data(), Number);
                        var fieldName = $inputs[0].name;
                        var viewFieldTypesMatchStr = 'daydeposit|weekdeposit|monthdeposit';
                        var validationFieldTypesMatchStr = 'day|week|month';

                        // can't be moved to regexp because of Reg builder `internal` type validation supports only fn and ajax
                        if (!regexInt.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.positiveInt');

                            return false;
                        }

                        // check another fields
                        var fields = form.$el.find('[data-validation-type=depositCountLimit]');
                        if (!fields.length) {
                            fields = form.$el.find('.fn-deposit-limit-generic');
                        }

                        if (!form.validationInProgress) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }
                        // format to {day:, week:, month:} for easy validation
                        var formattedData = _.keys(data).reduce(function(memo, limitName) {
                            var matched = limitName.match(viewFieldTypesMatchStr);
                            if (matched) {
                                memo[matched[0].split('deposit')[0]] = data[limitName];
                            }
                            return memo;
                        }, {});

                        if (form.options.isRegistrationForm) {
                            // check daily <= weekly <= monthly
                            var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

                            if (!validationHelpers.isFitLimitAmount[currentLimitName](formattedData)) {
                                this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName);
                                return false;
                            }
                        }

                        return true;
                    }
                }
            }
        };
    };
});
